<template>
  <div>
    <mdb-tbl class="ml-3 my-2 fsize-m" sm >
      <mdb-tbl-head>
        <tr class="">
          <th>과목명</th>
          <th>시작일</th>
          <th>종료일</th>
        </tr>
      </mdb-tbl-head>
      <mdb-tbl-body>
        <tr v-for="(s, i) in subjects" :key="i">
          <td class="pointer" @click="onSelectPlan(s)">
            <mdb-icon icon="chalkboard-teacher" /> {{s.name}}</td>
          <td>{{$strDate(s.startDate)}}</td>
          <td>{{$strDate(s.endDate)}}</td>
        </tr>
      </mdb-tbl-body>
    </mdb-tbl>

    <div v-if="subject" class="clearfix underline my-4">
      <div class="float-left sub-title bolder ">
        <mdb-icon icon="edit" /> {{subject && subject.name}} 계획 작성
      </div>
      <div class="float-right">
        <save-btn-sm class="mr-2" @click="onSave">저장</save-btn-sm>
        <delete-btn-sm @click="onDelete">삭제</delete-btn-sm>
      </div>
    </div>
    <plan-edit v-if="subject" :plan="subject.plan" :lectures="subject.lectures"/>
  </div>
</template>

<script>
import { mdbCard, mdbCardBody, mdbCardTitle, mdbCardText, mdbTbl, mdbTblHead, mdbTblBody } from 'mdbvue';
import PlanEdit from './PlanEdit.vue';
import Plan from '@/models/Plan.js';
export default {
  name: 'PlansEdit',
  components: { PlanEdit },
  props: ['subjects'],
  data: () => ({
    subject: undefined
  }),
  methods: {
    startDate (subject) {
      if (subject.lectures) {
        return this.$strDate(subject.lectures[0].startDate)
      }
    },
    endDate (subject) {
      if (subject.lectures) {
        return this.$strDate(subject.lectures[subject.lectures.length - 1].startDate)
      }
    },
    onSelectPlan (subject) {
      this.subject = subject
      if (!subject.plan || !subject.plan._id) { // 계획이 없으면 새로 생성
        subject.plan = Plan.create(subject._id)
      }
    },
    async onSave () {
      if (!confirm('저장할까요?')) return
      // this.subject.plan = await this.subject.plan.save()
      await this.subject.save()
    },
    async onDelete () {
      if (!confirm('삭제할까요?')) return
      // await this.subject.plan.delete()
      this.subject.plan = {}
      await this.subject.save()
    }
  }
}
</script>
